var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('b-col',{staticClass:"mb-10",attrs:{"md":"12"}},[_c('b-alert',{attrs:{"show":"","variant":_vm.variant}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }